import React from 'react';

import TimelineWrapper from '../../components/TimelineWrapper';
import TimelineContainer from '../../components/TimelineContainer';
import TimelineCard from '../../components/TimelineCard';

import iconBackground from '../../assets/icon_background.svg';
import iconBed from '../../assets/icon_bed.svg';
import iconCalculated from '../../assets/icon_calculated.svg';
import iconChart from '../../assets/icon_chart.svg';
import iconCore from '../../assets/icon_core.svg';
import iconLearning from '../../assets/icon_learning.svg';
import iconNavigate from '../../assets/icon_navigate.svg';
import iconOwnIt from '../../assets/icon_ownit.svg';
import iconPartner from '../../assets/icon_partner.svg';

const Culture = () => {
  return (
    <TimelineWrapper>
      <TimelineContainer>
        <TimelineCard
          icon={iconBed}
          heading="Sleep well at night"
          body="Ethics drive our actions, even when it requires hard conversations. Openness, honesty and transparency are the foundations of our integrity."
        />
        <TimelineCard
          icon={iconBackground}
          heading="Protect the investor"
          body="The investor is top of mind.  We are their advocate, constantly fighting on their behalf to mitigate risk and deliver positive results."
        />
      </TimelineContainer>
      <TimelineContainer>
        <TimelineCard
          icon={iconOwnIt}
          heading="Own it"
          body="We own our successes and we own our mistakes. We deliver on our commitments and are accountable both to ourselves and to our team. We figure out a way to create solutions."
        />
        <TimelineCard
          icon={iconCore}
          heading="Details matter"
          body="We are thorough and uncomfortable with mediocrity.  Our robust processes allow us to deliver consistent, timely, high-quality work product to our team, our clients and our investors."
        />
      </TimelineContainer>
      <TimelineContainer>
        <TimelineCard
          icon={iconPartner}
          heading="The Golden Rule"
          body="We treat our team and our clients with the same respect we would hope to receive from them. We communicate positively, professionally and proactively."
        />
        <TimelineCard
          icon={iconChart}
          heading="Spend Profitably"
          body="We are innovating and disrupting real estate finance. Every dollar saved is a dollar we can invest in this mission."
        />
      </TimelineContainer>
      <TimelineContainer>
        <TimelineCard
          icon={iconLearning}
          heading="Love of learning"
          body="We are uncomfortable with status quo. We have a continuous hunger for improvement. We are curious and we are always learning to be better."
        />
        <TimelineCard
          icon={iconNavigate}
          heading="Climb Mount Everest"
          body="Everyone has value to contribute to the team. We multiply our successes when we work together and lift each other up."
        />
      </TimelineContainer>
      <TimelineContainer>
        <TimelineCard
          icon={iconCalculated}
          heading="Take calculated risks"
          body="Thorough analysis enables us to seize the big opportunities that shape our future."
        />
      </TimelineContainer>
    </TimelineWrapper>
  );
};

export default Culture;
